import { FetchDocumentResponse, FetchDocumentsRequestBody } from "@documents/models/api.models";
import { AppThunkAPI } from "@shared/models/redux";
import { RequestConfig } from "@shared/models/request";
import { createInFlightPromiseCache } from "@shared/utils/inFlightRegistry";

type CallDocumentsAPI = (
  body: FetchDocumentsRequestBody,
  options?: RequestConfig<FetchDocumentsRequestBody>
) => AppThunkAPI<Promise<FetchDocumentResponse>>;

const inFlightSearches = createInFlightPromiseCache<string, FetchDocumentResponse>();

const sortIfArray = <T>(value: T): T => {
  if (Array.isArray(value)) {
    return [...value].sort() as unknown as T;
  }

  return value;
};

const buildSearchRequestKey = (body: FetchDocumentsRequestBody): string => {
  const normalized: Record<string, unknown> = {};
  const bodyAsRecord = body as unknown as Record<string, unknown>;
  const keys = Object.keys(bodyAsRecord).sort();

  for (const key of keys) {
    const value = bodyAsRecord[key];

    if (value === undefined) continue;
    normalized[key] = sortIfArray(value);
  }

  return JSON.stringify(normalized);
};

export const callDocumentsAPI: CallDocumentsAPI = (body, options) => async (_dispatch, _state, extra) => {
  const exec = async (): Promise<FetchDocumentResponse> => {
    const response = await extra<FetchDocumentResponse>("/documents/v1/Users/documents/search", {
      ...options,
      method: "post",
      body,
    });

    if (response.status === 204) {
      return { total: 0, results: [] };
    }

    return response.data;
  };

  // Abortable requests carry per-caller signals, so they must not share an
  // in-flight promise; only de-duplicate plain (non-abortable) searches.
  if (options?.signal) {
    return exec();
  }

  return inFlightSearches.run(buildSearchRequestKey(body), exec);
};
